<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('scope.text_676')"
    icon="menu-tenant"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :data="detailData"
      :res-id="data.id"
      :getParams="getParams"
      :on-manager="onManager"
      @refresh="refresh"
      @single-refresh="singleRefresh"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import HistoricalRateList from './HistoricalRateList'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'

export default {
  name: 'HistoricalRateSidePage',
  components: {
    Actions,
    HistoricalRateList,
  },
  mixins: [SidePageMixin, WindowsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('scope.text_677'), key: 'historical-rate-list' },
      ],
    }
  },
  computed: {
    getParams () {
      return null
    },
  },
}
</script>
